// extracted by mini-css-extract-plugin
module.exports = {"main-component":"simProfileArrow_main-component__3oQoj"};